import { formatearMoneda, precioVenta } from '@barbones/shared';
import { Campo, Input, Select } from '@/components/ui/form';

export interface ValorPrecio {
  costo: string;
  margenTipo: 'porcentaje' | 'fijo';
  margen: string;
}

const centavos = (t: string) => Math.round((Number.parseFloat(t) || 0) * 100);

/** Convierte el formulario a lo que espera la API (porcentaje ×100 o centavos). */
export function aMargenApi(v: ValorPrecio) {
  return { tipo: v.margenTipo, valor: centavos(v.margen) };
}

export function desdeProducto(p: { costo: number; margenTipo: 'porcentaje' | 'fijo'; margenValor: number }): ValorPrecio {
  return { costo: (p.costo / 100).toString(), margenTipo: p.margenTipo, margen: (p.margenValor / 100).toString() };
}

/** Costo del proveedor + ganancia (porcentaje o monto fijo) → precio al cliente, calculado en vivo. */
export function CamposPrecio({
  valor,
  onCambiar,
  deshabilitarMargen,
  bloquearCosto,
  etiquetaCosto = 'Precio de compra (costo)',
}: {
  valor: ValorPrecio;
  onCambiar: (v: ValorPrecio) => void;
  deshabilitarMargen?: boolean;
  bloquearCosto?: boolean;
  etiquetaCosto?: string;
}) {
  const precio = precioVenta(centavos(valor.costo), aMargenApi(valor));
  return (
    <div className="grid gap-3 sm:grid-cols-[1fr_1fr_1fr_auto] sm:items-end">
      <Campo etiqueta={etiquetaCosto} requerido>
        {(p) => <Input {...p} type="number" min="0" step="0.01" inputMode="decimal" disabled={bloquearCosto} value={valor.costo} onChange={(e) => onCambiar({ ...valor, costo: e.target.value })} className="cifras" />}
      </Campo>
      <Campo etiqueta="Tipo de ganancia">
        {(p) => (
          <Select {...p} value={valor.margenTipo} disabled={deshabilitarMargen} onChange={(e) => onCambiar({ ...valor, margenTipo: e.target.value as ValorPrecio['margenTipo'] })}>
            <option value="porcentaje">Porcentaje</option>
            <option value="fijo">Monto fijo</option>
          </Select>
        )}
      </Campo>
      <Campo etiqueta={valor.margenTipo === 'porcentaje' ? 'Ganancia (%)' : 'Ganancia (MXN)'}>
        {(p) => (
          <Input {...p} type="number" min="0" step="0.01" inputMode="decimal" disabled={deshabilitarMargen} value={valor.margen} onChange={(e) => onCambiar({ ...valor, margen: e.target.value })} className="cifras" />
        )}
      </Campo>
      <div className="rounded-md bg-accent-soft px-3 py-2">
        <p className="text-[11px] uppercase tracking-wide text-foreground-muted">Precio de venta</p>
        <p data-testid="precio-venta" className="cifras font-display text-[20px] leading-tight">
          {formatearMoneda(precio)}
        </p>
      </div>
    </div>
  );
}
